module.exports = __webpack_public_path__ + "img/rebel.bcc74ea8.png";